import React from 'react'

export function Glyphicon<Props>(
  props: { glyph: string } & Props,
): React.ReactElement {
  return <span className={`fa fa-${props.glyph}`} />
}
